<template>
  <div class="historyState" v-show="curIdx > -1">
      <!-- 底部显示 -->
      <div class="bottNav" :class="{'slide-in': showBottom, 'slide-out': !showBottom}">
         <div class="seting" v-if="!menuWay">
          <div class="item flex-center" @click="isShowChoose = !isShowChoose">
            <img class="setIcon" src="https://llss-file.langsounds.com/miniapp/863b5cf6b0f13bcecf0f45513c36c09a.png" alt="">
            <span>菜单样式</span>
          </div>
          <div class="clsChoose flex-center" v-if="isShowChoose">
            <div :class="['cItem flex-center', menuWay === i && 'curAct']" v-for="(item, i) of wayList" :key="i" @click="changeWay(i)">
              <img class="img" :src="item.icon" alt="">
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
        <ul class="menu flex-center">
          <li class="menuLi flex-center" :class="curIdx === idx && 'on'" v-for="(item, idx) in menus" :key="idx"
            @click="jumpPage(item, idx)">
            {{ item.text }}
          </li>
        </ul>
      </div>
      <div class="menuSwitch flex-center" :class="{'posiNo':getIsCourseMenu}" v-if="getIsCourseMenu ? (!menuWay && showBottom) : !menuWay" @click="chnageStatus">
        <p class="iconfont xiala1" :class="{'rotate-close': !showBottom, 'rotate-open': showBottom}"></p>
        <p>{{showBottom ? '收起菜单' : '展开菜单'}}</p>
      </div>
    <template v-if="menuWay">
      <div class="hsWrap">
        <span class="iconfont fanhui back" :data-idx="getHistoryIndex" :class="!getHistoryIndex && 'disabled'" @click="handleHistory(1)"></span>
        <span class="iconfont fanhui forward" :data-idx="getHistoryStack.length" :class="getHistoryStack.length - getHistoryIndex < 2 && 'disabled'" @click="handleHistory(0)"></span>
      </div>
      <div class="navMenu" :class="$route.path == '/book/course' && 'hasBtm'">
        <!-- {{ getHistoryIndex }}-{{ getHistoryStack.length }}-{{ getHistoryIndex <= getHistoryStack.length - 1 }} -->
        <ul class="nmUl">
          <li class="nmLi flex-center" :class="curIdx === idx && 'on'" v-for="(item, idx) in menus" :key="idx"
            @click="jumpPage(item, idx)">
            {{ item.text }}
          </li>
        </ul>
      </div>
      <div class="seting"  :class="{'botPosi': getIsCourseMenu && !showBottom}">
      <div class="item flex-center" @click="isShowChoose = !isShowChoose">
        <img class="setIcon" src="https://llss-file.langsounds.com/miniapp/863b5cf6b0f13bcecf0f45513c36c09a.png" alt="">
        <span>菜单样式</span>
      </div>
      <div class="clsChoose flex-center" v-if="isShowChoose">
        <div :class="['cItem flex-center', menuWay === i && 'curAct']" v-for="(item, i) of wayList" :key="i" @click="changeWay(i)">
          <img class="img" :src="item.icon" alt="">
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import util from 'libs/util';
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      menus: [
        {
          text: '朗朗首页', 
          url: '/course/home',
        },
        {
          text: '课件资源',
        },
        {
          text: '班级管理',
          url: '/course/manage',
        },
        {
          text: '课后管理',
          url: '/course/after',
        }
      ],
      curIdx: -1,
      canGoBack: false,
      canGoForward: false,
      wayList: [
        {
          name: '底部样式',
          icon: 'https://llss-file.langsounds.com/miniapp/9aba6575e7114ef8966ade8e0d01bddd.png',
        },
        {
          name: '侧边样式',
          icon: 'https://llss-file.langsounds.com/miniapp/9198cb9269528a32ecdbefdf5747084d.png',
        },
      ],
      isShowChoose: false,
      showBottom: true,
      menuWay: +sessionStorage.getItem('menuWay') || 0,
    };
  },
  computed: {
    ...mapGetters(["getHistoryStack","getHistoryIndex","getIsCourseMenu"]),
  },
  created() {
    if (this.$route.path.includes('/book/')) {
      this.curIdx = 1;
    } else {
      this.curIdx = this.menus.findIndex(item => item.url == this.$route.path);
    }
    if (this.$route.path.includes('/book/course')) {
      this.showBottom = false;
      sessionStorage.setItem('menustatus', 0);
    } else {
      let status = sessionStorage.getItem('menustatus');
      this.showBottom = this.menuWay ? false : (status == null ? true : +status);
    }
  },
  methods: {
    jumpPage({ url }, idx) {
      if (url == this.$route.path) return
      if (url) {
        this.$gopage(url, {});
      } else {
        let id = util.getStorage('LLSH_LAST_WARE');
        this.$gopage('book_ware', {
          id
        })
      }
    },
    handleHistory(isBack=1) {//1回退，0前进
      const idx = isBack ? this.getHistoryIndex - 1 : this.getHistoryIndex + 1;
      const url = this.getHistoryStack[idx];
      if(url)this.$router.push(url);
      // if(isBack) {
      //   this.$router.push(this.getHistoryStack[this.getHistoryIndex - 1]);
      // } else {
      //   this.$router.push(this.getHistoryStack[this.getHistoryIndex + 1]);
      // }
    },
    changeWay(i) {
      this.menuWay = i;
      sessionStorage.setItem("menuWay", i);
      this.$store.commit('setMenuWay', i);
      this.isShowChoose = false;
      this.showBottom = true;
      sessionStorage.setItem('menustatus', 1);
      if (i) this.showBottom = false; 
    },
    chnageStatus() {
      this.showBottom = !this.showBottom;
      this.isShowChoose = false;
      sessionStorage.setItem('menustatus', this.showBottom ? 1 : 0);
      sessionStorage.setItem("menuWay", 0);
      this.menuWay = 0;
      this.$store.commit('setMenuWay', 0);
    },

  }
};
</script>

<style lang="less" scoped>
@h: 60px;

.historyState{
  position: relative;
}
.hsWrap {
  width: 80px;
  cursor: pointer;
  padding-left: 20px;
  margin-right: -15px;

  .iconfont {
    display: inline-block;
    padding: 12px;
    color: #FB7C33;
    &.disabled {
      opacity: .3;
      cursor: not-allowed;
    }
  }

  .forward {
    transform: rotate(180deg);
  }
}

.navMenu {
  height: calc(100% - @h);
  position: fixed;
  left: 0;
  top: @h;
  width: 120px;
  // background: rgba(255, 255, 255, .6);
  background-color: #fff;
  border-right: 1px solid #ECECEC;

  &.hasBtm {
    height: calc(100% - 80px - @h);
  }

  .nmUl {
    font-size: 14px;
    color: #666666;
    padding-top: 18px;

    .nmLi {
      margin-bottom: 10px;
      height: 44px;
      position: relative;
      cursor: pointer;

      &.on {
        background: rgba(251, 124, 51, .1);
        color: #FB7C33;
        font-weight: bold;

        &::before {
          content: '';
          display: block;
          width: 4px;
          height: 20px;
          background: #FB7C33;
          border-radius: 0px 100px 100px 0px;
          position: absolute;
          left: 0;
        }
      }
    }
  }
}
  .seting{
    position: fixed;
    bottom: 20px;
    left: 0;
    width: 120px;
    z-index: 10;
    background: #FFFFFF;

    &.botPosi{
      bottom: 100px;
    }

      .item{
        flex-direction: column;
        color: #666666;
        font-size: 14px;
        cursor: pointer;
        
        .setIcon{
          width: 25px;
          height: 24px;
          margin-bottom: 8px;
        }
      }

      .clsChoose{
        width: 272px;
        height: 148px;
        background: #FFFFFF;
        box-shadow: 0px 4px 7px 0px rgba(0,0,0,0.1);
        border-radius: 10px;
        position: absolute;
        right: -250px;
        top: -120px;
        justify-content: space-around;

        .cItem{
          color: #666666;
          font-size: 12px;
          cursor: pointer;
          flex-direction: column;

          &.curAct{
            position: relative;
            color: #333333;
            &::after{
              content: '';
              width: 100%;
              height: 100%;
              background: url('https://llss-file.langsounds.com/miniapp/219dc74610d1d44174712a1abc13d2df.png') no-repeat;
              background-size: contain;
              position: absolute;
              top: 0;
              left: 0;
            }
          }

          .img{
            width: 102px;
            height: 81px;
            margin-bottom: 8px;
          }
        }
      }
  }

  .bottNav{
    width: 100%;
    height: 106px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1);
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9;
    transform: translateY(100%);
    transition: transform 0.2s ease-in-out;
    
    &.slide-in {
      transform: translateY(0);
    }
    
    &.slide-out {
      transform: translateY(100%);
    }

    .menu{
      height: 100%;

      .menuLi{
        color: #666666;
        font-size: 22px;
        // min-width: 10%;
        padding: 0 3%;
        height: 68px;
        margin: 0 20px;
        line-height: 68px;
        cursor: pointer;
        white-space: nowrap;

        &.on{
          background: url("https://llss-file.langsounds.com/miniapp/173154c6c1837eb6ae2c303dc9af34a9.png") no-repeat;
          background-size: 100% 100%;
          text-shadow: 0px 3px 2px rgba(32,183,80,0.2);
          color: #FB7C33;
          font-weight: bold;
        }
      }
    }
  }

  .menuSwitch{
    width: 100px;
    height: 100px;
    background: #FFFFFF;
    border-radius: 50%;
    position: fixed;
    bottom: 0;
    right: 10px;
    color: #666666;
    font-size: 14px;
    z-index: 9;
    flex-direction: column;
    cursor: pointer;

    &.posiNo{
      height: 80px;
      border-radius: 0;
      // display: none;
    }

    .icon{
      width: 25px;
      height: 24px;
      object-fit: contain;
      margin-bottom: 6px;
    }

    .xiala1{
      transition: transform 0.3s ease;
      color: #FB7C33;
      font-size: 30px;
      margin-bottom: 6px;
      transform: rotate(180deg);
    }


    .rotate-open {
      transform: rotate(0deg);
    }

    .rotate-close {
      transform: rotate(180deg);
    }

    .alternate-icon {
      transition: transform 0.3s ease, margin 0.3s ease;
    }

    .alternate-rotate-open {
      transform: rotate(0deg);
      margin-right: 8px;
    }

    .alternate-rotate-close {
      transform: rotate(180deg);
      margin-left: 8px;
    }
  }

</style>
